module.exports = __webpack_public_path__ + "static/media/jola-dark.329d97bd.svg";